/**
 * Ob der CRM-Dialog nach dem letzten erledigten Auftrag automatisch aufgeht.
 *
 * Der Dialog ist doppelt belegt: Für registrierte Nutzer ist er der Belegversand, für alle anderen
 * die Registrierungs-Aufforderung. Das auftragsbezogene Veto (planung-stories#879) betrifft nur die
 * Registrierung — der Belegversand hängt an eigenen Einstellungen und bleibt erreichbar.
 */
export const shouldOpenAutomaticCrmDialog = ({
    showModalAfterLastJobCompletedEnabled,
    isRegistered,
    isRegistrationAllowed,
}: {
    showModalAfterLastJobCompletedEnabled: boolean;
    isRegistered: boolean;
    isRegistrationAllowed: boolean;
}) => showModalAfterLastJobCompletedEnabled && (isRegistered || isRegistrationAllowed);
